import {useEffect, useRef} from 'react';

export function useLongPoll(
  requestFn: () => Promise<unknown>,
  intervalMs: number,
  maxRetries: number,
  limitCallback?: () => void,
) {
  let retries = useRef(1).current;
  const timerRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);

  return {
    start: () => {
      timerRef.current = setInterval(async () => {
        if (retries >= maxRetries) {
          clearInterval(timerRef.current!);
          limitCallback?.();
          return;
        }

        try {
          await requestFn();
        } catch (error) {
          // Handle error if needed
        }

        retries += 1;
      }, intervalMs);
    },
    stop: () => {
      if (timerRef.current) clearInterval(timerRef.current);
    },
  };
}
